import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";

export const useTracking = () => {
  const trackClick = (index: string, totalPhoto: string) => {
    sendGATracking({
      action: "Article Gallery Widget/Click",
      category: "Article Gallery Widget",
      label: window.location.href,
    });

    sendGA4Tracking({
      action: "click",
      category: "recirculation",
      customized_parameters: {
        page_type: "article",
        widget_name: "article_gallery",
      },
      subcategory: "widget",
    });

    if (index === "1") {
      sendGA4Tracking({
        action: "imp",
        category: "recirculation",
        customized_parameters: {
          page_type: "article",
          photo_num: index,
          total_photo: totalPhoto,
          widget_name: "article_gallery",
        },
        subcategory: "widget",
      });
    }
  };

  return {
    trackClick,
  };
};
